var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "17px",
    viewBox: "0 0 12 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DE50C546-FBBB-4A55-AFDB-9A8A9F8880E3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-300.000000, -1563.000000)",
    fill: "#AEAEAE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-75",
    transform: "translate(231.000000, 1562.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(69.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.76822128,9.92186554 L10.6331797,14.5598156 C10.9867437,14.9840925 10.9294197,15.6146572 10.5051428,15.9682213 C10.3254278,16.1179838 10.0988949,16.2 9.86495839,16.2 L2.13504161,16.2 C1.58275686,16.2 1.13504161,15.7522847 1.13504161,15.2 C1.13504161,14.9660635 1.21705783,14.7395306 1.36682033,14.5598156 L5.23177872,9.92186554 C5.5853428,9.49758864 6.2159075,9.44026457 6.6401844,9.79382866 C6.68664746,9.83254788 6.72950206,9.87540247 6.76822128,9.92186554 Z",
    id: "Triangle-Copy-15",
    transform: "translate(6.000000, 12.600000) scale(1, -1) translate(-6.000000, -12.600000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76822128,0.921865536 L10.6331797,5.5598156 C10.9867437,5.9840925 10.9294197,6.6146572 10.5051428,6.96822128 C10.3254278,7.11798378 10.0988949,7.2 9.86495839,7.2 L2.13504161,7.2 C1.58275686,7.2 1.13504161,6.75228475 1.13504161,6.2 C1.13504161,5.96606349 1.21705783,5.7395306 1.36682033,5.5598156 L5.23177872,0.921865536 C5.5853428,0.497588638 6.2159075,0.440264575 6.6401844,0.793828656 C6.68664746,0.832547876 6.72950206,0.875402471 6.76822128,0.921865536 Z",
    id: "Triangle-Copy-16"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.f24e8582dbcc93fc45ac3011cd48723e.svg";
export { ForwardRef as ReactComponent };